angular.module('aq.filters').filter('findById', function() {
   return function(list, id) {
       return _.findById(list, id);
   }
});